import { useParams, useSearchParams, useNavigate, Link, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { Icon } from 'react-icons-kit'
import {basic_eye} from 'react-icons-kit/linea/basic_eye';
import {basic_eye_closed} from 'react-icons-kit/linea/basic_eye_closed';
import RightContent from "../../components/OnBoard/RightContent";
import styles from "./UserOnboarding2.module.css";
import Menu from "../../components/OnBoard/Menu";
import { BASE_URL, CREATE_ISSUER, EMAIL_SIGNUP, GET_GSTIN_DETAILS, GET_PAN_STATUS, REGISTER_VERIFIER, VERIFY_TOKEN } from "../../Utils/constant";
import Error from "../../components/OnBoard/Error";
import cogoToast from "cogo-toast-react-17-fix";
import { logout } from "../../Utils/Redux/UserSlice";

import { useDispatch, useSelector } from "react-redux";
import API from "../../ApiConfig";
import { Delay, EMAIL_CHECK, NAME_CHECK, OFFSHORE_PHONE_CHECK, PASSWORD_CHECK, PHONE_CHECK } from "../../Utils/helper";
import SlideUpWrapper from "../../components/Transitions/SlideUpWrapper";
import Loader from "../../components/Loader";
import { BUTTONS } from "../../Utils/Strings";


import {Country, State, City} from "country-state-city";

const Onboarding = () => { 
  const navigate = useNavigate()
  const dispatch = useDispatch()
  let { token } = useParams();
  const [vToken, setVToken] = useState(true)
  const [consentCheck, setConsent] = useState(false)
  const [error, setError] = useState({})
  const [IsVerifier,setIsVerifier]=useState(false)
  const [searchParams] = useSearchParams();
  const[email ]=useState(searchParams.get("email"));
  const[companyName,setCompanyName]=useState('');
  const[passVisible,setPassVisible]=useState({passField:false, confirmField:false})
  const [CompanyLogo, setLogo] = useState({ url:'/insertlogo.png', file: null })
  const [FormValues,setFormValues]=useState({
    fullname:"",
    phoneNumber:"",
    password:"",
    confirmPassword:"",
    addressField1:"",
    addressField2:"",
    pinCodeField:"",
    countryField:"",
    stateField:"",
    gstinField:"",
    cityField:"",
    panField:""
  })
  const [showCountrySuggestion, setCountrySuggestion]=useState(false)
  const [showStateSuggestion, setStateSuggestion]=useState(false)

  const [showCitySuggestion, setCitySuggestion]=useState(false)
  const countries=Country.getAllCountries()
  const states =FormValues.countryField? State.getStatesOfCountry(countries.find((c)=>c.name===FormValues.countryField)?.isoCode ||""):[]
  const cities= FormValues.stateField? City.getCitiesOfState(countries.find((c)=>c.name===FormValues.countryField)?.isoCode,states.find((s)=>s.name===FormValues.stateField)?.isoCode ||""):[]
  const [loading,setLoading]=useState(false)
  const [skipGstPan, setSkipGstPan] = useState(false);
  const countryRef = useRef(null)
  const stateRef= useRef(null)

  const cityRef=useRef(null)
  const location=useLocation()
  
  
  const filterList = (countryList = [], userInputValue = "", key = "name") => {
    if (!Array.isArray(countryList)) return [];
    if (!userInputValue) return countryList; // show all if no input
  
    return countryList.filter((item) =>
      item[key]?.toLowerCase().includes(userInputValue.toLowerCase())
    );
  }
  const User=useSelector(state=>state.User)
  const showLogoImage = (image) => {
    let valid = false
    const checkValid = () => {
      if (image.target.files[0].type == 'image/png') {
        valid = true
      }
      if (image.target.files[0].size < 100) {
        valid = true
      }
    }
    checkValid()
    try {
      if (valid) {
        setLogo({ url: URL.createObjectURL(image.target.files[0]), file: image.target.files[0] })
      }
      else {
        cogoToast.error("Please upload only PNG files")
      }
    }
    catch {
      cogoToast.error("Some Error Occured, Please Upload Again")
    }
    finally {
      image.target.value = null;
    }
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (countryRef.current && !countryRef.current.contains(event.target)) {
        setCountrySuggestion(false);
      }

      if (stateRef.current && !stateRef.current.contains(event.target)) {
        setStateSuggestion(false);
      }

      if (cityRef.current && !cityRef.current.contains(event.target)) {

        setCitySuggestion(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [])
  const verifyToken = ()=>{
    API.post(VERIFY_TOKEN,{email, token})
      .then(data =>{
        let res=data.data
        var apiData = res.data

        localStorage.setItem(
          "user_data",JSON.stringify({
            "email": email,
            "phone_number": apiData.phone_number,
            "user_id": apiData.user_id,
            "id": apiData.issuer_id,
            "user_type":apiData.user_type,
            "verifier_id":apiData.verifier_id,
            "IsVerifier": apiData.verifier_id?true:false
          })
        )

        setCompanyName(apiData.company_name)
        if(res.data.has_accepted_terms==false){
          navigate("/Term-and-Policy", {state:{user_id:apiData.issuer_id || apiData.verifier_id, user_type:apiData.user_type}})
          localStorage.setItem("Url",location.pathname+location.search)
        }
        if(res.data.has_accepted_terms==true){
          localStorage.removeItem("Url")
        }
        if(apiData.verify!=true){
          setVToken(false)
        }
        if(apiData.user_state=="ONBOARDED"){
          navigate("/login")
        }

        if(apiData.phone_number!=null && apiData.user_state!="ONBOARDED"){
          navigate("/app/registration/step1")
        }
        if(apiData.verifier_id){
          setIsVerifier(true);
        }
      })
      .catch(err=>
        cogoToast.error(err.message)
      )
  }

  useEffect(()=>{
    // dispatch(logout())
    // verifyToken()
  },[])
  
  const handleSubmit= async (e)=>{
    e.preventDefault(); 
    if(Validate()){
      let formData=new FormData();
      formData.append("name", FormValues.fullname)
      formData.append("email", email)
      formData.append("phone_number", FormValues.phoneNumber)

      formData.append("password", FormValues.password)
      formData.append("confirm_password", FormValues.confirmPassword)
      formData.append("address1", FormValues.addressField1)
      formData.append("address2", FormValues.addressField2)
      formData.append("country", FormValues.countryField)
      formData.append("state", FormValues.stateField)
      formData.append("city", FormValues.cityField)
      formData.append("pincode", FormValues.pinCodeField)
      formData.append("gstin", FormValues.gstinField)
      formData.append("pan", FormValues.panField)
      formData.append("offshore",skipGstPan)
      if(CompanyLogo.file)
        formData.append("logo", CompanyLogo.file)
      const USER=IsVerifier? REGISTER_VERIFIER:CREATE_ISSUER
      setLoading(true)
      API.post(USER, formData)
        .then(data =>{
          setLoading(false)
          let res=data.data
          if(res.status==200){
            let user_data = JSON.parse(localStorage.getItem('user_data'));
            user_data['user_id'] = res.data.user_id
            user_data['name'] = res.data.name
            user_data['phone_number'] = res.data.phone_number
            localStorage.setItem("user_data",JSON.stringify(user_data));
            navigate("/app/registration/step1")
          }
        })
        .catch(err=>{
          setLoading(false);
          cogoToast.error(err.response.data.detail,{hideAfter:5})
        })
    }
  }

  const Validate=()=>{
    let isValid=true
    const newErrors={};
    if(!FormValues.fullname){
      isValid=false
      newErrors.fullname='Name is required!!'
      setConsent(false)
    }
    else if(!NAME_CHECK(FormValues.fullname)){
      isValid=false
      newErrors.fullname='Please enter alphabetic characters!!'
      setConsent(false)
    }
    if(!FormValues.phoneNumber){
      isValid=false
      newErrors.phoneNumber='Phone number is required!!'
    }
    else if(!skipGstPan && !PHONE_CHECK(FormValues.phoneNumber)){
      isValid=false
      newErrors.phoneNumber='Please enter numeric value!!'
      setConsent(false);
    }
    else if(skipGstPan && !/^[0-9]+$/.test(FormValues.phoneNumber)){
      isValid=false
      newErrors.phoneNumber='Please enter numeric value!!'
      setConsent(false);
    }
    if(!FormValues.password){
      isValid=false
      newErrors.password='Password is required!!'
      setConsent(false)
    }
    else if(!PASSWORD_CHECK(FormValues.password)){
      isValid=false
      newErrors.password='Your password should be between 8 to 13 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character!!'
      setConsent(false)
    }
    if(!FormValues.confirmPassword){
      isValid=false
      newErrors.confirmPassword='Please confirm your password!!'
      setConsent(false)
    }
    else if(FormValues.password !== FormValues.confirmPassword){
      isValid=false
      newErrors.confirmPassword='Password do not matched!!'
      setConsent(false)
    }
    if(!FormValues.addressField1){
      isValid=false
      newErrors.addressField1="Please enter address1 !!"
      setConsent(false)
    }
    if(FormValues.addressField1 && FormValues.addressField1.trim().length < 3){
      isValid=false
      newErrors.addressField1="Minimum length of address should be 3 characters!!"
      setConsent(false)
    }
    if(!FormValues.addressField2){
      isValid=false
      newErrors.addressField2="Please enter address2 !!"
      setConsent(false)
    }
    if(FormValues.addressField2 && FormValues.addressField2.trim().length < 3){
      isValid=false
      newErrors.addressField2="Minimum length of address should be 3 characters!!"
    }
    // if(!FormValues.gstinField && !skipGstPan){
    //   isValid=false
    //   newErrors.gstinField="Please Enter GSTIN!!"
    //   setConsent(false)
    // }
    if(!FormValues.countryField){
      isValid=false
      newErrors.countryField="Please enter country name!!"
      setConsent(false)
    }
    if(!countries.some(c=>c.name===FormValues.countryField) && skipGstPan){
      isValid=false
      newErrors.countryField="Please enter correct  country name!!"
      setConsent(false)
    }
    if(!FormValues.stateField){
      isValid=false
      newErrors.stateField="Please enter state name!!"
      setConsent(false)
    }
    if(!states.some(s=>s.name===FormValues.stateField) && skipGstPan){
      isValid=false
      newErrors.stateField="Please enter correct state name!!"
      setConsent(false)
    }
    if(!FormValues.cityField){
      isValid=false
      newErrors.cityField="Please enter city name!!"
      setConsent(false)
    }
    if(!cities.some(si=>si.name===FormValues.cityField) && skipGstPan){
      isValid=false
      newErrors.cityField="Please enter correct city name!!"
      setConsent(false)
    }
    if(!FormValues.panField && !skipGstPan){
      isValid=false
      newErrors.panField="Please enter PAN number!!"
      setConsent(false)
    }
    if(!FormValues.pinCodeField && !skipGstPan){
      isValid=false
      newErrors.pinCodeField="Please enter pin code!!"
      setConsent(false)
    }
    setError(newErrors);
    return isValid;
  }
  const handleVisibility=(field)=>{
    setPassVisible((prevState) => ({
      ...prevState,
      [field]: !prevState[field]
    }))
}
const getGstinDetails=()=>{
  setLoading(true)
  API.get(GET_GSTIN_DETAILS+ FormValues.gstinField)
  .then(res=>{
    if(res.data.status==200){
      setLoading(false)
      setFormValues(prev => ({
        ...prev,
        addressField1: res.data.data.address1 || '',
        addressField2:res.data.data.address2 || '',
        cityField:res.data.data.city || '',
        pinCodeField:res.data.data.pin_code || '',
        stateField:res.data.data.state_name || '',
        countryField:res.data.data.country || ''
      }))
    }
    else{
      cogoToast.error("Error while fetching details")
    }   
  })
  .catch(err=>{
    setLoading(false)
    console.log(err);
    
  })
}
useEffect(()=>{
  const timer = setTimeout(() => {
    if (FormValues.gstinField.length === 15) {
      getGstinDetails();
    }
  }, 500);

  return () => clearTimeout(timer)
}, [FormValues.gstinField])


const getPanStatus=()=>{
  setLoading(true)
  API.get(GET_PAN_STATUS + FormValues.panField)
  .then(res=>{
    setLoading(false)
    if(res.data.status==200){
      
    }
    else{
      setLoading(false)
      cogoToast.error("Error in PAN Number")
    }
  })
  .catch(err=>{
    setLoading(false)
    cogoToast.error(`${err.response.data.message}`)
    console.log(err);
    
  })
}
useEffect(()=>{
  const timer = setTimeout(() => {
    if (FormValues.panField.length===10) {
      getPanStatus()

    }
  }, 500);
  return () => clearTimeout(timer)
},[FormValues.panField])
  if(!vToken){
    return(<Error Message={"Invalid Token"} subMessage="Token either expired or invalid, please contact administrator for more info"/>)
  }
  const [errors, setErrors]=useState({})
  const SubmitEmail=(e)=>{
    e.preventDefault()
    if(!ValidateEmail()) return;
    else{
    setLoading(true)
    API.post(EMAIL_SIGNUP,{email:FormValues.email})
    .then(res=>{
      if(res.status==200){
        setLoading(false)
        localStorage.setItem(
          "user_data",
          JSON.stringify({ email: FormValues.email })
        )
        navigate("/app/Onboarding/step1")
        cogoToast.success(res.data.message)
      }
    })
    .catch(err=>{
      setLoading(false)
      cogoToast.error(err.response.data.message)
    })
  }
  }

  const ValidateEmail = () => {
    const newErrors = {};
    const blockedDomains = [
      "gmail.com",
      "yahoo.com", "yahoo.co.in", "yahoo.in",
      "hotmail.com",
      "outlook.com",
      "live.com",
      "icloud.com",
      "me.com",
      "aol.com",
      "protonmail.com", "proton.me",
      "zoho.com",
      "rediffmail.com",
      "mail.com",
      "gmx.com",
      "yandex.com",
      "msn.com",
    ];
  
    if (!FormValues.email) {
      newErrors.email = "Email is required";
    } else if (!EMAIL_CHECK(FormValues.email)) {
      newErrors.email = "Enter a valid email";
    } else {
      const domain = FormValues.email.split("@")[1]?.toLowerCase();
      if (!domain) {
        newErrors.email = "Please enter a valid email address";
      } else if (blockedDomains.includes(domain)) {
        newErrors.email = "Please use your organization email address";
      }
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // true if valid
  }
  
  return (
    <>
  <SlideUpWrapper direction="slide-left">
    <Loader isOpen={loading}/>
    <div className={styles.userOnboarding}>
      <RightContent subtract="/subtract.svg"  step={1}/>
      <section className={styles.leftContent}>
        <div className={styles.progressForm} style={{height:"100%"}}>
          <div className={styles.progressForm1}>
            {/* <Menu pos="2" USER={IsVerifier}/> */}
            <div className={styles.headingHelperText}>
                <h1 className={styles.headingText}>Join the trust layer</h1>
                <h1 className={`${styles.headingText} ${styles.headingText2}`}>for enterprise documents.</h1>
                <p className={styles.supportingText}>
                Issue, verify and share documents with cryptographic confidence. Start by confirming your work email — we’ll handle the rest.
                    </p>
              </div>
            <div className={styles.form}>
            <form onSubmit={(e)=>SubmitEmail(e)} style={{width:"100%"}}>

              <div className={styles.emailContainer}>

                <label>Work Email Address</label>
                <div className={styles.userInputBox} style={{width:"100%"}}>
                <input type="email" id="email" value={FormValues.email} name="email" placeholder="name@authbridge.com" onChange={(e)=>{setFormValues({...FormValues,email:e.target.value});setErrors(prev=>({...prev,email:""}))}} />
                {errors.email && <span style={{color:"red",fontWeight:"500"}}>{errors.email}</span>}
                </div>
                <div className={FormValues.email?styles.SubmitBtn:styles.disableButton} style={{margin:"1rem 0"}}>
                <button type="submit" disabled={!FormValues.email}>{loading?BUTTONS.VERIFYING:"Continue"}</button>
              </div>
              </div>
              {/* <div style={{marginBottom:"1rem", display:"flex", alignItems:"center", gap:"10px",marginRight:"215px",marginTop:"10px"}}>
                <label className={styles.toggleSwitch}>
                  <input 
                    type="checkbox" 
                    checked={skipGstPan} 
                    onChange={() =>{ setSkipGstPan(!skipGstPan), setFormValues({...FormValues,gstinField:"", pinCodeField:"", panField:""})}} 
                  />
                  <span className={styles.slider}></span>
                </label>
                <span style={{fontWeight:"500", fontSize:"14px"}}>
                  Are you an Offshore client? (Skip GSTIN / PAN)
                </span>
              </div> */}
              {/* <div className={styles.inputs}>
              <div className={styles.mainUserInfo}>

              <div className={styles.userInputBox}>
                <label htmlFor="firstname">Name</label>
                <input type="text" id="firstname" name="firstname" value={FormValues.fullname} placeholder="e.g.Bonnie Green" onChange={(e)=>{setFormValues({...FormValues,fullname:e.target.value})}} />
              {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
              </div>
              <div className={styles.userInputBox}>
                <label htmlFor="email" style={{display:"flex", flexDirection:"row"}}>Email <p className="astric">*</p></label>
                <input type="email" id="email" name="email" placeholder="name@flowbite.com" disabled value={email}/>
              </div>

              <div className={styles.userInputBox}>
                <label htmlFor="phone">Phone</label>
                <input type="tel" id="phone" value={FormValues.phoneNumber} name="phone" placeholder="9876543210" onChange={(e)=>{setFormValues({...FormValues,phoneNumber:e.target.value})}} maxLength={skipGstPan?20:10} />
              {error.phoneNumber && <span style={{color:"red",fontWeight:"500"}}>{error.phoneNumber}</span>}              </div>
              <div className={styles.userInputBox}>
                <label htmlFor="CompanyName">Company Name</label>
                <input type="text" id="CompanyName" name="CompanyName" placeholder="ABC Private Ltd" onChange={(e)=>{setCompanyName(e.target.value)}} value={companyName} disabled={companyName.length>1}/>
              </div>

              <div className={styles.userInputBox}>                
                <label htmlFor="password" style={{display:"flex", flexDirection:"row"}}>Password <p className="astric">*</p></label>
                <div className={styles.passField}>
                <input type={passVisible.passField?"text":"password"} id="password" name="password" value={FormValues.password} placeholder="" style={{border:"hidden"}} onChange={(e)=>{setFormValues({...FormValues,password:e.target.value})}} maxLength={13}/>
                
                <span onClick={()=>handleVisibility('passField')}><Icon icon={passVisible.passField? basic_eye:basic_eye_closed} size={20}/></span>
                </div> 
              {error.password && <span style={{color:"red",fontWeight:"500"}}>{error.password}</span>}
              </div>

              <div className={styles.userInputBox}>
                <label htmlFor="ConfirmPassword" style={{display:"flex", flexDirection:"row"}}>Confirm Password <p className="astric">*</p></label>
                <div className={styles.passField}>
                <input type={passVisible.confirmField?"text":"password"} id="ConfirmPassword" name="ConfirmPassword" value={FormValues.confirmPassword} placeholder="" style={{border:"hidden"}} onChange={(e)=>{setFormValues({...FormValues,confirmPassword:e.target.value})}} maxLength={13}/>
               
                <span onClick={()=>handleVisibility('confirmField')}><Icon icon={passVisible.confirmField? basic_eye:basic_eye_closed} size={20}/></span>
                </div>
              {error.confirmPassword && <span style={{color:"red",fontWeight:"500"}}>{error.confirmPassword}</span>}
              </div>


              {!skipGstPan && (
                <div className={styles.userInputBox}>
                  <label htmlFor="GSTIN" style={{display:"flex", flexDirection:"row"}}>
                    GSTIN
                  </label>
                  <div className={styles.passField}>
                    <input 
                      type="text" 
                      id="GSTIN" 
                      value={FormValues.gstinField} 
                      placeholder="e.g 3RZHGP4605L6Z8" 
                      style={{border:"hidden", width:"100%"}} 
                      onChange={(e)=>setFormValues({...FormValues,gstinField:e.target.value})} 
                      maxLength={15}
                    />
                  </div>
                  {error.gstinField && <span style={{color:"red",fontWeight:"500"}}>{error.gstinField}</span>}
                </div>
              )}
              {!skipGstPan &&

              <div className={styles.userInputBox}>
                  <label htmlFor="pincode" style={{display:"flex", flexDirection:"row"}}>
                    Pin code<p className="astric">*</p>
                  </label>
                  <div className={styles.passField}>
                    <input 
                      type="text" 
                      id="pincode" 
                      value={FormValues.pinCodeField} 
                      placeholder="147201" 
                      style={{border:"hidden", width:"100%"}} 
                      onChange={(e)=>setFormValues({...FormValues,pinCodeField:e.target.value})} 
                      maxLength={10}
                    />
                  </div>
                  {error.pinCodeField && <span style={{color:"red",fontWeight:"500"}}>{error.pinCodeField}</span>}
              </div>}

              
              <div className={styles.userInputBox} style={{position:"relative"}} ref={countryRef}>
                <label htmlFor="country" style={{display:"flex",flexDirection:"row"}}>Country <p className="astric">*</p></label>
                <input 
                  type="text" 
                  id="country" 
                  value={FormValues.countryField} 
                  placeholder="e.g India" 
                  onChange={(e)=>{setFormValues({...FormValues,countryField:e.target.value}), setCountrySuggestion(true)}}
                  onFocus={() => setCountrySuggestion(true)} 


                  onBlur={() => {
                    const matched = countries.some(
                      (c) => c.name.toLowerCase() === FormValues.countryField.toLowerCase()
                    );
                    if (!matched && FormValues.countryField.trim() !== "") {
                      setError((prev) => ({
                        ...prev,
                        countryField: "Invalid country name. Please select from the list.",
                      }));
                    } else {
                      setError((prev) => ({ ...prev, countryField: "" }));
                    }
                  }}
                />
                {error.countryField && <span style={{color:"red",fontWeight:"500"}}>{error.countryField}</span>}
                {showCountrySuggestion && FormValues.countryField && (
          <ul
          
          style={{

            position: "absolute",
            fontSize:"16px",
            top: "100%",
            left: 0,
            width: "100%",
            background: "white",
            border: "1px solid #ccc",
            margin: 0,
            padding: 0,
            listStyle: "none",
            maxHeight: "200px",
            overflowY: "auto",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            zIndex: 9999
          }}
          >
            {filterList(countries, FormValues.countryField).length>0?
            filterList(countries, FormValues.countryField)?.map((c) => {
              return(
              <li
                key={c.isoCode}
                style={{ padding: "6px", cursor: "pointer" }}
                onClick={() => {
                  setFormValues({...FormValues,countryField:c.name});
                  setCountrySuggestion(false);
                  setError((prev)=>({...prev, countryField:""}))
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f0f0")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
              >
                {c.name}
              </li>
            )}):<li style={{ padding: "6px"}}>No Country</li>}
          </ul>
        )}
                {/* <label htmlFor="firstname">Country</label> */}
                {/* <input type="text" id="firstname" name="firstname" value={FormValues.countryField} placeholder="e.g India" onChange={(e)=>{setFormValues({...FormValues,countryField:e.target.value})}} disabled />
              {error.countryField && <span style={{color:"red",fontWeight:"500"}}>{error.countryField}</span>} */}
              {/* </div> */}


              {/* <div className={styles.userInputBox} style={{position:"relative"}} ref={stateRef}>
                <label htmlFor="state" style={{display:"flex", flexDirection:"row"}}>State <p className="astric">*</p></label>
                <input 
                  type="text" 
                  id="state" 
                  value={FormValues.stateField} 
                  placeholder="e.g Punjab" 
                  onChange={(e)=>{setFormValues({...FormValues,stateField:e.target.value}), setStateSuggestion(true)}} 
                  disabled={showCountrySuggestion==true} 
                  onFocus={()=>setStateSuggestion(true)}
                  onBlur={() => {
                    const matched = states.some(
                      (c) => c.name.toLowerCase() === FormValues.stateField.toLowerCase()
                    );
                    if (!matched && FormValues.stateField.trim() !== "") {
                      setError((prev) => ({
                        ...prev,
                        stateField: "Invalid state name. Please select from the list.",
                      }));
                    } else {
                      setError((prev) => ({ ...prev, stateField: "" }));
                    }
                  }}
                />
                {error.stateField && <span style={{color:"red",fontWeight:"500"}}>{error.stateField}</span>}
                {showStateSuggestion && FormValues.stateField && (
          <ul
          
          style={{

            position: "absolute",
            fontSize:"16px",
            top: "100%",
            left: 0,
            width: "100%",
            background: "white",
            border: "1px solid #ccc",
            margin: 0,
            padding: 0,
            listStyle: "none",
            maxHeight: "200px",
            overflowY: "auto",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            zIndex: 9999
          }}
          >
            { filterList(states, FormValues.stateField).length>0?
            filterList(states, FormValues.stateField)?.map((s) => {
              return(
              <li
                key={s.isoCode}
                style={{ padding: "6px", cursor: "pointer" }}
                onClick={() => {
                  setFormValues({...FormValues,stateField:s.name});
                  setStateSuggestion(false);
                  setError((prev) => ({ ...prev, stateField: "" }))
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f0f0")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
              >
                {s.name}
              </li>
            )}): <li style={{padding:"6px"}}>No State</li>}
          </ul>
        )}
              </div>
              <div className={styles.userInputBox} style={{position:"relative"}} ref={cityRef}>
                <label htmlFor="city" style={{display:"flex", flexDirection:"row"}}>City <p className="astric">*</p></label>
                <input 
                  type="text" 
                  id="city" 
                  value={FormValues.cityField} 
                  placeholder="City" 
                  onChange={(e)=>{setFormValues({...FormValues,cityField:e.target.value}), setCitySuggestion(true)}} 
                  disabled={!(!showCountrySuggestion && !showStateSuggestion)}
                  onFocus={()=>setCitySuggestion(true)}
                  onBlur={() => {
                    const matched = cities.some(
                      (c) => c.name.toLowerCase() === FormValues.cityField.toLowerCase()
                    );
                    if (!matched && FormValues.cityField.trim() !== "" && FormValues.gstinField=="" && FormValues.panField=="") {
                      setError((prev) => ({
                        ...prev,
                        cityField: "Invalid city name. Please select from the list.",
                      }));
                    } else {
                      setError((prev) => ({ ...prev, cityField: "" }));
                    }
                  }}
                />
                {error.cityField && <span style={{color:"red",fontWeight:"500"}}>{error.cityField}</span>}
                {showCitySuggestion && FormValues.cityField && (
          <ul
          
          style={{

            position: "absolute",
            fontSize:"16px",
            top: "100%",
            left: 0,
            width: "100%",
            background: "white",
            border: "1px solid #ccc",
            margin: 0,
            padding: 0,
            listStyle: "none",
            maxHeight: "200px",
            overflowY: "auto",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            zIndex: 9999
          }}
          >
            { filterList(cities,FormValues.cityField).length>0?
            filterList(cities, FormValues.cityField)?.map((ci) => {
              return(
              <li
                key={ci.isoCode}
                style={{ padding: "6px", cursor: "pointer" }}
                onClick={() => {
                  setFormValues({...FormValues,cityField:ci.name});
                  setCitySuggestion(false);
                  setError((prev)=>({...prev, cityField:""}))
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f0f0")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
              >
                {ci.name}
              </li>
            )}):<li style={{padding:"6px"}}>No City</li>}
          </ul>
        )}
              </div>
              {!skipGstPan && (
                <div className={styles.userInputBox}>
                  <label htmlFor="pan" style={{display:"flex", flexDirection:"row"}}>
                    Pan No.<p className="astric">*</p>
                  </label>
                  <div className={styles.passField}>
                    <input 
                      type="text" 
                      id="pan" 
                      value={FormValues.panField} 
                      placeholder="AAAFA1234A" 
                      style={{border:"hidden", width:"100%"}} 
                      onChange={(e)=>setFormValues({...FormValues,panField:e.target.value})} 
                      maxLength={10}
                    />
                  </div>
                  {error.panField && <span style={{color:"red",fontWeight:"500"}}>{error.panField}</span>}
                </div>
              )}
              </div>
              <div className={styles.userInputBox} style={{width:"98.5%"}}>
                <label htmlFor="ConfirmPassword" style={{display:"flex", flexDirection:"row"}}>Address Line 1 <p className="astric">*</p></label>
                <div className={styles.passField} style={{width:"100%"}}>
                <input type="text" id="ConfirmPassword" name="ConfirmPassword" value={FormValues.addressField1} placeholder="122, BAKER STREET" style={{border:"hidden", width:"100%"}} onChange={(e)=>{setFormValues({...FormValues,addressField1:e.target.value})}}/>
                </div>
              {error.addressField1 && <span style={{color:"red",fontWeight:"500"}}>{error.addressField1}</span>}
              </div>

              <div className={styles.userInputBox} style={{width:"98.5%"}}>
                <label htmlFor="ConfirmPassword" style={{display:"flex", flexDirection:"row"}}>Address Line 2 <p className="astric">*</p></label>
                <div className={styles.passField} style={{width:"100%"}}>
                <input type="text" id="ConfirmPassword" name="ConfirmPassword" value={FormValues.addressField2} placeholder="122, BAKER STREET" style={{border:"hidden", width:"100%"}} onChange={(e)=>{setFormValues({...FormValues,addressField2:e.target.value})}}/>
                </div>
              {error.addressField2 && <span style={{color:"red",fontWeight:"500"}}>{error.addressField2}</span>}
              </div>
              <div style={{margin:"15px 0px"}}>
                <div className={styles.LogoBox}>
                  <div className={styles.image3} style={loading ? {border:'none'}:null}>
                  {loading ? (
                    <div className='shimmer' style={{ height:"100%"}} />
                    ) : (
                         <img className={styles.imac27Gallery13Icon} loading="eager" alt="" src={CompanyLogo.url} />
                        )}
                      <img className={styles.trashIcon} alt="" src="/trash.svg" onClick={() => setLogo({url:'/imac27gallery1-3@2x.png', file:null})} />
                  </div>
              <div className={styles.textNavItem}>
                <div className={styles.dividerContentInputfield}>
                <label htmlFor="fileInput" className={styles.uploadLabel}>
                  <div className={styles.uploadbutton}>
                    <img className={styles.uploadOutlineIcon} alt="" src="/uploadoutline.svg" />
                    Upload logo
                    <input type="file" id="fileInput" style={{ display: "none" }} className={styles.fileInput} onChange={(e) => showLogoImage(e)} accept="image/png, image/jpeg" />
                  </div>
                  </label>
                  <span className={styles.helperBackgroundUpload}>*Only PNG allowed</span>
                </div>
              </div>
          </div>
              </div>
              {skipGstPan==true&&
              <div className={styles.Policy}>
                <ul>
                  <li className={styles.policyCheck} style={{color:"#1c64f2"}}>If you are an offshore client, a $10 deduction will be applied for each search</li>
                </ul>
              </div>}
                <div className={styles.Policy}>
                  <input type="checkbox" checked={consentCheck} onClick={e=>setConsent(!consentCheck)} />
                  <span className={consentCheck?styles.policyCheck:styles.Check}> By Signing up, you are creating an AuthNumber account, and you agree to Authbridge's Terms's of Use and <a href="https://authbridge.com/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{color:"var(--primary-600)", textDecoration:"none"}}>Privacy Policy</a>.</span>
                </div> */}
              {/* </div> */}
              {/* <div className={consentCheck?styles.SubmitBtn:styles.disableButton} style={{margin:"1rem 0"}}>
                <button type="submit" disabled={!consentCheck}>{loading?BUTTONS.VERIFYING:"Verify Email"}</button>
              </div>              */}
            </form>
            </div>
            <div style={{textAlign:"center"}}>
            <p style={{margin:"10px 0px"}}>Personal email providers aren’t supported — we verify your domain</p>

            <p>By continuing you agree to our <a href="https://authbridge.com/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{color:"var(--primary-600)", textDecoration:"none"}}>Privacy Policy</a> Already have an account? <Link to="/login" style={{color:"var(--primary-600)", textDecoration:"none"}}>Sign in</Link></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </SlideUpWrapper>
  </>
  );
};

export default Onboarding;
